import process from "node:process";
import { ref, toRef, watch } from "@nuxtjs/composition-api";
import { useWindowScroll, useScroll as vueUseScroll } from "@vueuse/core";
function useScroll() {
  const isScrollingBottom = ref(false);
  const element = ref();
  if (process.client) {
    element.value = window;
  }
  const { directions } = vueUseScroll(element.value);
  const top = toRef(directions, "top");
  const bottom = toRef(directions, "bottom");
  const { y } = useWindowScroll();
  watch(
    [bottom, y],
    ([newBottomDirection, newY]) => {
      if (newBottomDirection && !isScrollingBottom.value && Number(newY) > 0) {
        isScrollingBottom.value = true;
      }
    }
  );
  watch(
    top,
    (newTopDirection) => {
      if (newTopDirection && isScrollingBottom.value) {
        isScrollingBottom.value = false;
      }
    }
  );
  return {
    isScrollingBottom
  };
}
;
export {
  useScroll as default
};
